module.exports = __webpack_public_path__ + "static/media/UploadFile.0a7c9ead.svg";